function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function formatMoney(money,format) {
  return Shopify.formatMoney(money, format)
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        this.querySelectorAll(
          'button.mobile-facets__close-button'
        ).forEach((btn => {
          if (btn != detailsElement.querySelector('button.mobile-facets__close-button')) {
            btn.click()
          }
        })
        );
        if (detailsElement.classList.contains('.mobile-facets__details')) {
          detailsElement.open = true
        }
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
    this.toggleInnerMenu()
    this.toggleDetails()
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };

  toggleInnerMenu() {
    const menuItems = this.querySelectorAll('[data-target-tab-mobile]')
    const menuTabs = this.querySelectorAll('[data-tab-content-mobile]')
    menuItems.forEach((item) => {
      item.addEventListener('click', (ee) =>{
        menuItems.forEach(i => i.classList.remove('active'));
        menuTabs.forEach(i => i.classList.remove('active'));
        item.classList.add('active')
        const activeTab = this.querySelector(`[data-tab-content-mobile=${item.dataset.targetTabMobile}]`)
        if (activeTab) {
          activeTab.classList.add('active');
        }
      })
    })
  }

  toggleDetails() {
    // Fetch all the details element.
    const maindetails = this.querySelectorAll("details[data-main-link-details]");
    const subdetails = this.querySelectorAll("details[data-sub-details]");


    // Add the onclick listeners.
    maindetails.forEach((detail) => {
      detail.addEventListener("toggle", () => {
        if (detail.open) setTargetDetail(maindetails, detail);
      });
    });

    subdetails.forEach((detail) => {
      detail.addEventListener("toggle", () => {
        if (detail.open) setTargetDetail(subdetails, detail);
      });
    });

    // Close all the details that are not targetDetail.
    function setTargetDetail(maindetails, targetDetail) {
      maindetails.forEach((detail) => {
        if (detail !== targetDetail) {
          detail.open = false;
        }
      });
    }
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    if (this.dataset.unavailableHide == "true") {
      this.productJSON = this.querySelector('[data-product-json]').innerHTML;
    }
    if (this.dataset.unavailableHide == "true") {
      this.pickerType = 'radios'
      this.fieldsets = (this.pickerType == 'radios') ? Array.from(this.querySelectorAll('fieldset')) : Array.from(this.querySelectorAll('.product-form__input--dropdown'));
    }
    this.addEventListener('change', this.onVariantChange);
  }

  connectedCallback(){
    if (this.dataset.unavailableHide == "true") {
      this.rebuildOptions();
    }
    const modalPrintLabels = document.querySelectorAll('.prints-modal');
    const dataAddOnImagesEl = document.querySelectorAll('[data-addon-images]')
    const mainPrintLabels = this.querySelectorAll('.main__product-section [data-main-variants] fieldset label')

    // set currentColor button image
    const buttonAddOnEl = document.querySelector('.main__product-section .add__on-products');
    const plateAddOnEl = document.querySelector('.main__product-section .add__on-products');
    const currentMainVarColorEl = document.querySelector('.main__product-section product-variants [data-main-variants] .input--pill__color');
    let currentColor = '';
    if(currentMainVarColorEl) {
      currentColor = currentMainVarColorEl.querySelector('legend span').innerHTML
    }

    if(buttonAddOnEl && dataAddOnImagesEl.length) {
      buttonAddOnEl.querySelector('#buttons')?.querySelectorAll('input[type="radio"]').forEach(function(input,index){
        if(input.value == currentColor.trim() || currentColor.trim().includes(input.value)) {
          dataAddOnImagesEl.forEach(function(el){
            el.querySelector('[data-button-image]').setAttribute('src',input.nextElementSibling.getAttribute('data-image-url'))
          })
        } else {
          if(index == 0) {
            dataAddOnImagesEl.forEach(function(el){
              el.querySelector('[data-button-image]').setAttribute('src',input.nextElementSibling.getAttribute('data-image-url'))
            })
          }
        }
      })
    }

    if(plateAddOnEl && dataAddOnImagesEl) {
      plateAddOnEl.querySelector('#backplate')?.querySelectorAll('input[type="radio"]').forEach(function(input,index){
        if(input.value == currentColor.trim() || currentColor.trim().includes(input.value)) {
          dataAddOnImagesEl.forEach(function(el){
            el.querySelector('[data-plate-image]').setAttribute('src',input.nextElementSibling.getAttribute('data-image-url'))
          })
        } else {
          if(index == 0) {
            dataAddOnImagesEl.forEach(function(el){
              el.querySelector('[data-plate-image]').setAttribute('src',input.nextElementSibling.getAttribute('data-image-url'))
            })
          }
        }
      })
    }

    if(modalPrintLabels.length) {
        modalPrintLabels.forEach(function(modal){
            modal.querySelectorAll('label').forEach(function(label){
              label.addEventListener('click',function(e){
                  const values = e.target.dataset.value;
                 
                  mainPrintLabels.forEach(function(mainLabel){
                      if(mainLabel.dataset.value == values) {
                          mainLabel.click();
                          e.target.closest('modal-dialog').querySelector('.product-popup-modal__toggle').click()
                      }
                  })
              })
            })
        })
    }

    // checkbox change event
    const checkBoxes = document.querySelectorAll('.check_addon input[type="checkbox"]');
    const addOnProductsNameEl = document.querySelector('.add_on_products--name')
    const mainProductPrice = document.querySelector('.price-item--sale');
    let addOnTotal = 0 + Number(mainProductPrice?.innerHTML.trim().replace(/[^0-9.-]+/g,""));

    if(checkBoxes.length) {
      checkBoxes.forEach(function(checkbox){
        checkbox.addEventListener('change', (event) => {
          if (event.target.checked) {
            event.target.closest('.single_product').classList.add('active_addon');
            document.querySelector(`[data-addon-ids] [data-input-index="${event.target.dataset.checkIndex}"]`).disabled = false;

            if(addOnProductsNameEl) {
              addOnProductsNameEl.querySelector(`li[data-addon-index="${event.target.dataset.checkIndex}"]`).classList.remove('hidden')
            }

            const actualPrice = Number(event.target.closest('.single_product').querySelector('[data-price]').innerHTML.substring(1))
            addOnTotal += actualPrice;
          } else {
            event.target.closest('.single_product').classList.remove('active_addon');
            document.querySelector(`[data-addon-ids] [data-input-index="${event.target.dataset.checkIndex}"]`).disabled = true

            if(addOnProductsNameEl) {
              addOnProductsNameEl.querySelector(`li[data-addon-index="${event.target.dataset.checkIndex}"]`).classList.add('hidden')
            }

            const actualPrice = Number(event.target.closest('.single_product').querySelector('[data-price]').innerHTML.substring(1))
            addOnTotal -= actualPrice;
          }

          document.querySelector('.total-addon').innerHTML = 'Total price - ' + formatMoney(addOnTotal*100,window.moneyFormat)

          const ifOneChecked = Array.from(checkBoxes).some(checkbox => checkbox.checked);

          if(ifOneChecked) {
            addOnProductsNameEl.querySelector('li:first-child').classList.remove('hidden')
          } else {  
            addOnProductsNameEl.querySelector('li:first-child').classList.add('hidden')
          }
        });
      })
    }
  }

  onVariantChange(event) {
    
    this.updateOptions();
    this.updateMasterId();

    if (this.dataset.unavailableHide == "true") {
      this.rebuildOptions();
    }

    // update product card url
    if (this.currentVariant && this.closest('[data-product-card-wrapper]')) {
      const shopBtns = this.closest('[data-product-card-wrapper]').querySelectorAll('[data-product-card-url]')
      shopBtns.forEach(btn => btn.href = `${this.dataset.url}?variant=${this.currentVariant.id}`)
      console.log('update product card url');

      if(this.closest('[data-product-card-wrapper]').querySelector('.product-item-image-wrapper')) {
        this.closest('[data-product-card-wrapper]').querySelector('.product-item-image-wrapper img').setAttribute('src',this.currentVariant.featured_image.src)
        this.closest('[data-product-card-wrapper]').querySelector('.product-item-image-wrapper img').removeAttribute('srcset',this.currentVariant.featured_image.src)
      }
    };
    // update product card url ends
    
    if(this.closest('.product-variants')) {
      this.updateSelectedSwatchValue(event);
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      // this.removeErrorMessage();
      this.updateVariantStatuses();
    }

    if(this.closest('.product-variants')) {
      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        this.updateShareUrl();
      }
    }  
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
    
    console.log('this.currentVariant',this.currentVariant)

    const currentVariantIdEl = this.querySelector('[data-current-variant] input');
    const addOnPriceEl = this.closest('.single_product');
    const addOnEl = this.closest('details.add__on-products')

    // current add on var id append
    if(currentVariantIdEl && this.currentVariant != undefined) {
      currentVariantIdEl.value = this.currentVariant.id
    }

    if(addOnPriceEl && this.currentVariant != undefined) {
      addOnPriceEl.querySelector('[data-price]').innerHTML = formatMoney(this.currentVariant.price,window.moneyFormat);

      if(this.currentVariant.compare_at_price) {
        addOnPriceEl.querySelector('[data-compare-price]').innerHTML = formatMoney(this.currentVariant.compare_at_price,window.moneyFormat)
      }

      addOnPriceEl.querySelector('fieldset legend span').innerHTML = (this.currentVariant.option2 == null) ? this.currentVariant.option1 : this.currentVariant.option2;

      const addOnIndex = addOnPriceEl.dataset.index;

      // individual id append on upsell products
      if(addOnEl && addOnIndex && !addOnEl.classList.contains('print_addon')) {
        addOnEl.closest('.right_part').querySelectorAll('[data-addon-ids] input').forEach((input) => {
          const index = input.getAttribute('data-input-index');
          
          if(index == addOnIndex) {
            input.value = this.currentVariant.id;
          }
        })
      }

      if(addOnEl.classList.contains('print_addon')) {
        addOnEl.querySelector('.print_id input').value = this.currentVariant.id
      }
    }

    if (addOnEl) {
      // const varsOutOfStocks = Array.from(addOnEl.querySelectorAll('.single_product')).some(fieldset => {
      //   const inputs = fieldset.querySelectorAll('input[type="radio"]');
      //   return Array.from(inputs).some(input => input.checked && input.classList.contains('disabled'));
      // });

      // if(varsOutOfStocks) {
      //   addOnEl.querySelector('.add__on-footer button').disabled = true;
      //   addOnEl.querySelector('.add__on-footer button').classList.add('disabled')
      // } else {
      //   addOnEl.querySelector('.add__on-footer button').disabled = false;
      //   addOnEl.querySelector('.add__on-footer button').classList.remove('disabled')
      // }

      // total price updation
      // const priceElCount = addOnEl.querySelectorAll('.single_product');
      // const mainProductPrice = addOnPriceEl.closest('.right_part').querySelector('.price-item--sale');
      // let addOnTotal = 0 + Number(mainProductPrice?.innerHTML.trim().replace(/[^0-9.-]+/g,""));
      // priceElCount.forEach(function(price){
      //   const actualPrice = Number(price.querySelector('[data-price]').innerHTML.substring(1))
      //   addOnTotal += actualPrice
      // });
      // addOnEl.closest('.right_part').querySelector('.total-addon').innerHTML = 'Total price - ' + formatMoney(addOnTotal*100,window.moneyFormat)

      // image manipulate
      if(this.currentVariant != undefined) {
        const addOnImagesWrapper = document.querySelectorAll('[data-addon-images]');
        
        if(addOnImagesWrapper.length) {
         if(this.currentVariant.name.includes('Ring') && this.currentVariant.featured_image != null) {
          addOnImagesWrapper.forEach((el)=>{
            el.querySelector('[data-ring-image]').setAttribute('src',this.currentVariant.featured_image.src)
          })
         } else if(this.currentVariant.name.includes('Button') && this.currentVariant.featured_image != null) {
          addOnImagesWrapper.forEach((el)=>{
            el.querySelector('[data-button-image]').setAttribute('src',this.currentVariant.featured_image.src)
          })
         } else if(this.currentVariant.name.includes('Plate') && this.currentVariant.featured_image != null) {
          addOnImagesWrapper.forEach((el)=>{
            el.querySelector('[data-plate-image]').setAttribute('src',this.currentVariant.featured_image.src)
          })
         } else if(this.currentVariant.name.includes('Print') && this.currentVariant.featured_image != null) {
          addOnImagesWrapper.forEach((el)=>{
            el.querySelector('[data-print-image]').setAttribute('src',this.currentVariant.featured_image.src)
          })
         }
        }
      }

      const mediaBlock = document.getElementById('product-locationn');
      if (mediaBlock && window.matchMedia("(max-width: 768px)").matches) {
        mediaBlock.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
  
    }

    // ecosystem popup current id
    const ecoSystemModal = this.closest('.tabs_content');
    if(ecoSystemModal && this.currentVariant != undefined) {
      ecoSystemModal.querySelector('.product__buy-buttons input.product-variant-id').value = this.currentVariant.id 
    }

    const featureProductId = this.closest('.featued_product-new')

    if(featureProductId) {
      featureProductId.querySelector('.product-variant-id').value = this.currentVariant.id
    }

    // main price change 
    const productInfo = this.closest('product-info');
    if(productInfo && this.currentVariant != undefined && this.closest('.product-variants')) {
      const priceEl = productInfo.querySelector('.price-item--sale')
      const comparePriceEl = productInfo.querySelector('.price-item--regular');

      if(priceEl) {
        priceEl.innerHTML = formatMoney(this.currentVariant.price,window.moneyFormat)
      }
      if(comparePriceEl) {
        comparePriceEl.innerHTML = formatMoney(this.currentVariant.compare_at_price,window.moneyFormat)
      }
    }

    // update addon button with main image onchange of main product variant
    if(this.closest('.product-variants') && this.currentVariant != undefined) {
      let currentVarColor = this.currentVariant.option2;

      if(currentVarColor == null) {
        currentVarColor = this.currentVariant.option1
      }
      
      const buttonAddOnEls = document.querySelector('.main__product-section .add__on-products')
      const plateAddOnEls = document.querySelector('.main__product-section .add__on-products')
      const dataAddOnImagesEls = document.querySelectorAll('[data-addon-images]');

      if(buttonAddOnEls && dataAddOnImagesEls.length) {
        buttonAddOnEls.querySelector('#buttons')?.querySelectorAll('input[type="radio"]').forEach(function(input,index){
          if(input.value == currentVarColor.trim() || currentVarColor.trim().includes(input.value)) {
            dataAddOnImagesEls.forEach(function(el){
              el.querySelector('[data-button-image]').setAttribute('src',input.nextElementSibling.getAttribute('data-image-url'))
            })
          } 
          else {
            if(index == 0) {
              dataAddOnImagesEls.forEach(function(el){
                el.querySelector('[data-button-image]').setAttribute('src',input.nextElementSibling.getAttribute('data-image-url'))
              })
            }
          }
        })
      }

      if(plateAddOnEls && dataAddOnImagesEls.length) {
        plateAddOnEls.querySelector('#backplate')?.querySelectorAll('input[type="radio"]').forEach(function(input,index){
          if(input.value == currentVarColor.trim() || currentVarColor.trim().includes(input.value)) {
            dataAddOnImagesEls.forEach(function(el){
              el.querySelector('[data-plate-image]').setAttribute('src',input.nextElementSibling.getAttribute('data-image-url'))
            })
          } else {
            if(index == 0) {
              dataAddOnImagesEls.forEach(function(el){
                el.querySelector('[data-plate-image]').setAttribute('src',input.nextElementSibling.getAttribute('data-image-url'))
              })
            }
          }
        })
      }
    }
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    let colorValue = this.currentVariant.option2?.toLowerCase().replace(/ /g,'-');

    if(this.currentVariant.option2 == null) {
      colorValue = this.currentVariant.option1?.toLowerCase().replace(/ /g,'-');
    }
 
    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    const ThumbMediaGalleries = document.querySelector(`[id^="ThumbGalleryViewer-${this.dataset.section}"]`);
    const mainMediaGalleries = document.querySelector(`[id^="GalleryViewer-${this.dataset.section}"]`);
   
    // mediaGalleries.forEach((mediaGallery) =>
    //   mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    // );
    if (ThumbMediaGalleries) {
      let firstMatchIndex = -1;
      ThumbMediaGalleries.querySelectorAll('.swiper-slide').forEach((thumbImage,index)=>{
        thumbImage.classList.add('hidden')
        if(window.thumbslider) {
          let thumbAlts = thumbImage.dataset.mediaAlt.split('thumb-')[1];
          if(thumbAlts.includes('main')) {
            thumbAlts = thumbImage.dataset.mediaAlt.split('thumb-main-')[1];
          }
          if(colorValue === thumbAlts) {
            thumbImage.classList.remove('hidden')
            if (firstMatchIndex === -1) {
              firstMatchIndex = index;
            }
          }
        } 
      })
  
      if (firstMatchIndex !== -1 && window.thumbslider) {
        // Use Swiper's API to slide to the first matching slide
        window.mainGallarySlider.activeIndex = firstMatchIndex
        window.mainGallarySlider.update();
  
        ThumbMediaGalleries.querySelectorAll('.swiper-slide').forEach((thumbImage,index)=>{
          thumbImage.classList.remove('swiper-slide-thumb-active');
  
          if(index == firstMatchIndex) {
            thumbImage.classList.add('swiper-slide-thumb-active')
          }
        })
      }
    }

    // change addon case color
    const caseImageEl = document.querySelector('.add__on-products .first_image');
    if(caseImageEl) {
      caseImageEl.querySelector('img').setAttribute('src',this.currentVariant.featured_image.src)
    }

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  get selectedOptionValuesText() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueText
    );
  }

  findVariantByOptions() {
    const parsedProductJSON = this.productJSON ? JSON.parse(this.productJSON) : null
    console.log(parsedProductJSON, 'parsedProductJSON')
    return parsedProductJSON?.variants.find(variant => 
        this.selectedOptionValuesText.every((option, index) => variant.options[index] === option)
    );
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant?.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  validCombo(inputValue, optionLevel) {
    const parsedProductJSON = this.productJSON ? JSON.parse(this.productJSON) : null
    if (parsedProductJSON?.variants) {
      for(let i = 0; i < parsedProductJSON?.variants.length; i++) {
        if(optionLevel == 1){
          if (parsedProductJSON?.variants[i].option1 == this.selectedOptionValuesText[0] && parsedProductJSON?.variants[i].option2 == inputValue) { return true; }
        } else {
          if (parsedProductJSON?.variants[i].option1 == this.selectedOptionValuesText[0] && parsedProductJSON?.variants[i].option2 == this.selectedOptionValuesText[1] && parsedProductJSON?.variants[i].option3 == inputValue) { return true; }
        }
      }
    }
    return false;
  }

  rebuildOptions() {
    //loop through the option sets starting from the 2nd set and disable any invalid options
    for(let optionLevel = 1, n = this.fieldsets.length; optionLevel < n; optionLevel++) {
      const inputs = (this.pickerType == 'radios') ? this.fieldsets[optionLevel].querySelectorAll('input') : this.fieldsets[optionLevel].querySelectorAll('option');
  
      inputs.forEach(input => {
        // input.disabled = (validCombo(input.value,optionLevel)) ? false : true;
        input.dataset.optionUnavailable = (this.validCombo(input.value,optionLevel)) ? false : true;
        if(this.pickerType == 'radios'){
          //get the label for the current input (this is what the user clicks, the "pill")
          const label = this.fieldsets[optionLevel].querySelector(`label[for="${input.id}"]`);
  
          label.style.display = (input.dataset.optionUnavailable == 'true') ? "none" : ""; //Hide the option, or comment this line out and use the following lines to style it..
          //label.style.opacity = (input.dataset.optionUnavailable == 'true') ? 0.5 : 1;
          //label.style.borderStyle = (input.dataset.optionUnavailable == 'true') ? "dashed" : "solid";
          //label.style.textDecoration = (input.dataset.optionUnavailable == 'true') ? "none" : "";
        } else {
          input.hidden = (this.validCombo(input.value,optionLevel)) ? false : true;
        }
      });
    }
  
    //if the default selected option is disabled with the function above, select the first available option instead
    for (let optionLevel = 1, fieldsetsLength = this.fieldsets.length, change = false; optionLevel < fieldsetsLength && !change; optionLevel++) {
      if(this.pickerType == 'radios'){
        console.log(this.fieldsets[optionLevel])
        if(this.fieldsets[optionLevel].querySelector('input:checked').dataset.optionUnavailable == 'true') {
          console.log(this.fieldsets[optionLevel].querySelector('input:not([data-option-unavailable="true"])'), `this.fieldsets[optionLevel].querySelector('input:not([data-option-unavailable="true"])')`)
          change = (this.fieldsets[optionLevel].querySelector('input:not([data-option-unavailable="true"])').checked = true);
        }
      } else {
        if(this.fieldsets[optionLevel].querySelector('option:checked').disabled === true) {
          change = (this.fieldsets[optionLevel].querySelector('option:not(:disabled)').selected = "selected");
        }
      }
    }
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);


/**
 * Swiper 11.1.1
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2024 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: April 9, 2024
 */


//# sourceMappingURL=swiper-bundle.min.js.map

// Swiper component
class SwiperComponent extends HTMLElement {
  connectedCallback() {
    // Parse swiperSettings from data attributes
    this.swiperSettings = {
      ...this.parseSwiperSettings(),
    };

    // Initialize Swiper with settings
    this.swiper = new Swiper(this.querySelector('.js-swiper'), this.swiperSettings);

    // Expose method to check initialization status
    this.isInitialized = () => {
      return this.swiper !== undefined && this.swiper !== null;
    };
  }

  // Helper function to parse swiperSettings from data attributes
  parseSwiperSettings() {
    const settings = {};
    const dataAttributes = this.attributes;
    for (const attribute of dataAttributes) {
      const { name, value } = attribute;
      if (name === 'data-swiper-options') {
        Object.assign(settings, JSON.parse(value));
      }
    }
    return settings;
  }
}

customElements.define('swiper-component', SwiperComponent);

// Load more pagination
window.loadMorePagination = function loadMorePagination(context) {
  if (context.querySelector('.js-load-more')) {
    context.querySelector('.js-load-more').addEventListener('click', function() {
      console.log(context.querySelector('.js-load-more'))
      var button = this;
      var totalPages = parseInt(context.querySelector('[data-total-pages]').value);
      var currentPage = parseInt(context.querySelector('[data-current-page]').value);
    
      button.setAttribute('disabled', true);
      // button.querySelector('[loader]').classList.remove('hide');
      button.querySelector('[load-more-text]').classList.add('hidden');
      button.querySelector('.loading__spinner').classList.remove('hidden');
      currentPage = currentPage + 1;
    
      var nextUrl = context.querySelector('[data-next-url]').value.replace(/page=[0-9]+/, 'page=' + currentPage);
      context.querySelector('[data-current-page]').value = currentPage;
    
      fetch(nextUrl)
        .then(response => response.text())
        .then(responseHTML => {
          var parser = new DOMParser();
          var doc = parser.parseFromString(responseHTML, 'text/html');
          var newItems = doc.querySelector('#product-grid').innerHTML;
          if (window.location.href.includes('/search')) {
            newItems = doc.querySelector('#search-product-grid').innerHTML;
            context.querySelector('#search-product-grid').insertAdjacentHTML('beforeend', newItems);
          } else {
            context.querySelector('#product-grid').insertAdjacentHTML('beforeend', newItems);
          }
    
          // Check if we have reached the last page
          if (currentPage >= totalPages) {
            button.closest('.pagination-load-more-wrap').classList.add('hidden');
            } else {
              button.removeAttribute('disabled');
              button.querySelector('[load-more-text]').classList.remove('hidden');
              button.querySelector('.loading__spinner').classList.add('hidden');
              }
          button.closest('.pagination-load-more-wrap').innerHTML = doc.querySelector('.pagination-load-more-wrap').innerHTML
          window.loadMorePagination(context);
        })
        .catch(error => {
          console.error('Error fetching the next page:', error);
          // Optionally, re-enable the button if there was an error
          button.removeAttribute('disabled');
          button.querySelector('[load-more-text]').classList.remove('hidden');
          button.querySelector('.loading__spinner').classList.add('hidden');
        });
    });
  }
}
window.loadMorePagination(document);
// Load more pagination ends

document.addEventListener("DOMContentLoaded", () => {
  const ecoSystemTabs = document.querySelectorAll('.eco-system-modal .tabs ul li');
  const ecoBackButton = document.querySelector('.eco-system-modal [data-back-btn]');
  const ecoNextButton = document.querySelector('.eco-system-modal [data-next-btn]');
  const ecoSystemModal = document.querySelector('.eco-system-modal .product-popup-modal__content')
  if (ecoSystemModal) {
    var ecoModalEditButton = ecoSystemModal.querySelector("button[data-button-type='edit']")
  }

  const changeTab = (direction) => {
    const activeTab = document.querySelector('.eco-system-modal .tabs ul li.active');
    if (activeTab) {
      let newIndex;
      ecoSystemTabs.forEach((tab, index) => {
        if (tab === activeTab) {
          activeTab.classList.remove('active');
          if (direction === 'next') {
            newIndex = index + 1;
            if (newIndex < ecoSystemTabs.length) {
              ecoSystemTabs[newIndex].classList.add('active');
              ecoSystemTabs[newIndex].click();
              ecoSystemModal.scrollIntoView({ behavior: 'smooth', block: 'start' });
            } else {
              // If there is no next tab, re-add the active class to the current tab
              activeTab.classList.add('active');
            }
          } else {
            newIndex = index - 1;
            if (newIndex >= 0) {
              ecoSystemTabs[newIndex].classList.add('active');
              ecoSystemTabs[newIndex].click();
              ecoSystemModal.scrollIntoView({ behavior: 'smooth', block: 'start' });
            } else {
              // If there is no previous tab, re-add the active class to the current tab
              activeTab.classList.add('active');
            }
          }
        }
      });
    }
  };

  if (ecoNextButton) 
    ecoNextButton.addEventListener('click', () => changeTab('next'));

  if(ecoBackButton)
    ecoBackButton.addEventListener('click', () => changeTab('back'));

  if (ecoModalEditButton) {
    ecoModalEditButton.addEventListener('click',function(e){
      e.target.closest('modal-dialog').querySelector('.product-popup-modal__toggle').click()
    })
  }
});

// our story tabs
class StoryTabs extends HTMLElement {
  constructor() {
    super();
    this.tabTriggers = this.querySelectorAll('.js-our-story-tab');
    this.tabPanels = this.querySelectorAll('.js-our-story-tab-content');
    this.activeIndex = 0;
    this.interval = null;

    this.attachEventListeners();
    this.observeViewport();
  }
  
  attachEventListeners() {
    this.tabTriggers.forEach((trigger, index) => {
      trigger.addEventListener('click', () => {
        this.showPanel(index);
        this.resetInterval();
      });
    });
  }
  
  showPanel(index) {
    this.tabPanels.forEach((panel, panelIndex) => {
      panel.classList.toggle('active', panelIndex === index);
    });

    this.tabTriggers.forEach((trigger, triggerIndex) => {
      trigger.classList.toggle('active', triggerIndex === index);
    });

    this.activeIndex = index;
  }
  
  observeViewport() {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.startInterval();
        } else {
          this.stopInterval();
          this.showPanel(0);
        }
      });
    });

    observer.observe(this);
  }
  
  startInterval() {
    if (this.interval) return;
    this.interval = setInterval(() => {
      this.showPanel((this.activeIndex + 1) % this.tabTriggers.length);
    }, 3000);
  }
  
  stopInterval() {
    clearInterval(this.interval);
    this.interval = null;
  }
  
  resetInterval() {
    this.stopInterval();
    this.startInterval();
  }
}

customElements.define('story-tabs', StoryTabs);


// our story tabs ends


class InnovationsCarousels extends HTMLElement {
  constructor() {
    super();
    this.tabTriggers = this.querySelectorAll('[data-innv-tab-trigger]');
    this.tabPanels = this.querySelectorAll('[data-innv-tab-panel]');
    
    this.attachEventListeners();
  }
  
  attachEventListeners() {
    this.tabTriggers.forEach((trigger, index) => {
      trigger.addEventListener('click', () => {
        this.showPanel(index);
      });
    });
  }
  
  showPanel(index) {
    this.tabPanels.forEach((panel, panelIndex) => {
      if (panelIndex === index) {
        panel.classList.add('active')
      } else {
        panel.classList.remove('active')
      }
    });

    this.tabTriggers.forEach((trigger, triggerIndex) => {
      if (triggerIndex === index) {
        trigger.classList.add('active');
      } else {
        trigger.classList.remove('active');
      }
    });
  }
}

customElements.define('innovations-carousels', InnovationsCarousels);

window.addEventListener('load', function() {
  document.body.classList.add('loaded');
});